// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div#learnpress-gradebook-react {
  padding: 20px 20px 20px 0px;
}
div#learnpress-gradebook-react .breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e4e4e4;
  border-radius: 2px;
  margin-left: 0;
}
div#learnpress-gradebook-react .breadcrumb > li {
  margin: 0;
}
div#learnpress-gradebook-react .breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  color: #6c757d;
  content: "/";
}
div#learnpress-gradebook-react .breadcrumb a {
  cursor: pointer;
}

.learnpress-gradebook button .components-spinner {
  margin: 0 10px 0 0;
}
.learnpress-gradebook table th.index {
  width: 50px;
}
.learnpress-gradebook table thead th {
  color: #2271b1;
}
.learnpress-gradebook h2.title-head span {
  font-size: 14px;
}
.learnpress-gradebook .wrap-config {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.learnpress-gradebook .wrap-config .export-csv {
  width: 50%;
  display: flex;
  align-items: center;
  column-gap: 20px;
}
.learnpress-gradebook .wrap-config .export-csv input[type=search] {
  min-width: 400px;
}
.learnpress-gradebook .wrap-config .search-screen {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.learnpress-gradebook .wrap-config .search-screen form#posts-filter {
  display: flex;
  align-items: center;
}
.learnpress-gradebook .chart_sc {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  text-align: center;
  justify-content: space-between;
  align-items: end;
}
.learnpress-gradebook .chart_sc.chart_sc3 {
  text-align: left;
  justify-content: unset;
  align-items: center;
}
.learnpress-gradebook .chart_sc.chart_sc3 .quiz_detail {
  width: 30%;
}
.learnpress-gradebook .chart_sc.chart_sc3 .detail-chart {
  width: 22%;
}
.learnpress-gradebook .chart_sc .detail-chart {
  width: 45%;
}
.learnpress-gradebook .chart_sc .detail-chart__loading {
  position: relative;
}
.learnpress-gradebook .chart_sc .detail-chart__loading > :not(.components-spinner) {
  opacity: 0.2;
  pointer-events: none;
}
.learnpress-gradebook .chart_sc .detail-chart__loading > .components-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -10px;
  margin-left: -10px;
}
.learnpress-gradebook .chart_sc .detail-chart ul.subsubsub {
  margin-bottom: 20px;
}
.learnpress-gradebook .chart_sc .detail-chart ul.subsubsub li {
  margin-right: 5px;
}
.learnpress-gradebook .chart_sc .detail-chart .ct-chart {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.learnpress-gradebook .chart_sc .detail-chart .ct-chart .ct-left {
  width: 55%;
}
.learnpress-gradebook .chart_sc .detail-chart .ct-chart .ct-right {
  width: 45%;
  text-align: left;
}
.learnpress-gradebook .chart_sc .title-chart {
  display: flex;
  align-items: center;
}
.learnpress-gradebook .chart_sc .title-chart p {
  font-style: italic;
  font-size: 14px;
  padding-left: 10px;
}
.learnpress-gradebook .chart_sc .title-chart.center {
  justify-content: center;
}
.learnpress-gradebook .number_retake {
  display: inline;
  position: relative;
}
.learnpress-gradebook .number_retake span.count_retake {
  padding: 8px;
  cursor: pointer;
}
.learnpress-gradebook span.lp-gradebook-item__title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  width: 100%;
}
.learnpress-gradebook .lp-skeleton-animation li {
  width: 100%;
  height: 30px;
  border-radius: "4px";
}
.learnpress-gradebook .pagination {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
  margin-top: 20px;
}
.learnpress-gradebook .pagination li {
  position: relative;
  margin-left: -1px;
  line-height: 1.25;
  color: #2271b1;
  background-color: #fff;
  border: 1px solid #dee2e6;
  cursor: pointer;
}
.learnpress-gradebook .pagination li.active {
  z-index: 1;
  color: #fff;
  background-color: #2271b1;
  border-color: #2271b1;
}
.learnpress-gradebook .pagination li.active a {
  color: white;
}
.learnpress-gradebook .pagination li a {
  display: flex;
  width: 33px;
  height: 33px;
  justify-content: center;
  align-items: center;
}

.wp-list-table.lp-gradebook-spinner {
  position: relative;
}
.wp-list-table.lp-gradebook-spinner tbody {
  opacity: 0.2;
}
.wp-list-table.lp-gradebook-spinner > .components-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
}

.lp-gradebook-overlay {
  background-color: rgba(0, 0, 0, 0.05);
}
.lp-gradebook-overlay .components-modal__frame {
  box-shadow: 0 0 2px 0 #ccc;
}

.lp-gradebook_retake {
  width: 150px;
}
.lp-gradebook_retake .lp-gradebook_retake_detail {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 13px;
  font-weight: normal;
  background-color: #f6f7f7;
}
.lp-gradebook_retake .lp-gradebook_retake_detail:nth-child(2n+1) {
  background-color: #fff;
}

.components-dropdown__content.lp-gradebook_my_popover_content .components-popover__content {
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
  border-radius: 5px;
}
.components-dropdown__content.lp-gradebook_my_popover_content .components-popover__content > div {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./assets/src/scss/index.scss"],"names":[],"mappings":"AAAA;EACC,2BAAA;AACD;AACC;EACC,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AACF;AACE;EACC,SAAA;AACH;AAEE;EACC,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;AAAH;AAEE;EACC,eAAA;AAAH;;AAOE;EACC,kBAAA;AAJH;AASE;EACC,WAAA;AAPH;AAUG;EACC,cAAA;AARJ;AAcE;EACC,eAAA;AAZH;AAeC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAbF;AAeE;EACC,UAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAbH;AAeG;EACC,gBAAA;AAbJ;AAgBE;EACC,UAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAdH;AAgBG;EACC,aAAA;EACA,mBAAA;AAdJ;AAmBC;EACC,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;AAjBF;AAmBE;EACC,gBAAA;EACA,sBAAA;EACA,mBAAA;AAjBH;AAmBG;EACC,UAAA;AAjBJ;AAmBG;EACC,UAAA;AAjBJ;AAoBE;EACC,UAAA;AAlBH;AAoBG;EACC,kBAAA;AAlBJ;AAoBI;EACC,YAAA;EACA,oBAAA;AAlBL;AAqBI;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;AAnBL;AAuBG;EACC,mBAAA;AArBJ;AAsBI;EACC,iBAAA;AApBL;AAwBG;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAtBJ;AAwBI;EACC,UAAA;AAtBL;AAwBI;EACC,UAAA;EACA,gBAAA;AAtBL;AA0BE;EACC,aAAA;EACA,mBAAA;AAxBH;AA0BG;EACC,kBAAA;EACA,eAAA;EACA,kBAAA;AAxBJ;AA0BG;EACC,uBAAA;AAxBJ;AA6BC;EACC,eAAA;EACA,kBAAA;AA3BF;AA6BE;EACC,YAAA;EACA,eAAA;AA3BH;AA8BC;EACC,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;AA5BF;AAgCE;EACC,WAAA;EACA,YAAA;EACA,oBAAA;AA9BH;AAiCC;EACC,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AA/BF;AAiCE;EACC,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;AA/BH;AAiCG;EACC,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AA/BJ;AAgCI;EACC,YAAA;AA9BL;AAiCG;EACC,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AA/BJ;;AAsCC;EACC,kBAAA;AAnCF;AAqCE;EACC,YAAA;AAnCH;AAsCE;EACC,kBAAA;EACA,QAAA;EACA,SAAA;AApCH;;AAyCA;EACC,qCAAA;AAtCD;AAuCC;EACC,0BAAA;AArCF;;AAyCA;EACC,YAAA;AAtCD;AAuCC;EACC,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AArCF;AAuCE;EACC,sBAAA;AArCH;;AA0CC;EACC,2EAAA;EACA,kBAAA;AAvCF;AAwCE;EACC,UAAA;AAtCH","sourcesContent":["div#learnpress-gradebook-react {\r\n\tpadding: 20px 20px 20px 0px;\r\n\r\n\t.breadcrumb {\r\n\t\tdisplay: flex;\r\n\t\tflex-wrap: wrap;\r\n\t\tpadding: 0.75rem 1rem;\r\n\t\tmargin-bottom: 1rem;\r\n\t\tlist-style: none;\r\n\t\tbackground-color: #e4e4e4;\r\n\t\tborder-radius: 2px;\r\n\t\tmargin-left: 0;\r\n\r\n\t\t>li{\r\n\t\t\tmargin: 0;\r\n\t\t}\r\n\r\n\t\t.breadcrumb-item + .breadcrumb-item::before {\r\n\t\t\tdisplay: inline-block;\r\n\t\t\tpadding-right: 0.5rem;\r\n\t\t\tpadding-left: 0.5rem;\r\n\t\t\tcolor: #6c757d;\r\n\t\t\tcontent: \"/\";\r\n\t\t}\r\n\t\ta {\r\n\t\t\tcursor: pointer;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.learnpress-gradebook {\r\n\tbutton{\r\n\t\t.components-spinner{\r\n\t\t\tmargin: 0 10px 0 0;\r\n\t\t}\r\n\t}\r\n\r\n\ttable {\r\n\t\tth.index {\r\n\t\t\twidth: 50px;\r\n\t\t}\r\n\t\tthead {\r\n\t\t\tth {\r\n\t\t\t\tcolor: #2271b1;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\th2.title-head{\r\n\t\tspan{\r\n\t\t\tfont-size: 14px;\r\n\t\t}\r\n\t}\r\n\t.wrap-config {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tmargin-bottom: 20px;\r\n\r\n\t\t.export-csv {\r\n\t\t\twidth: 50%;\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tcolumn-gap: 20px;\r\n\r\n\t\t\tinput[type=\"search\"]{\r\n\t\t\t\tmin-width: 400px;\r\n\t\t\t}\r\n\t\t}\r\n\t\t.search-screen {\r\n\t\t\twidth: 50%;\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: flex-end;\r\n\t\t\talign-items: center;\r\n\r\n\t\t\tform#posts-filter {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.chart_sc {\r\n\t\twidth: 100%;\r\n\t\tmargin-bottom: 20px;\r\n\t\tdisplay: flex;\r\n\t\ttext-align: center;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: end;\r\n\r\n\t\t&.chart_sc3 {\r\n\t\t\ttext-align: left;\r\n\t\t\tjustify-content: unset;\r\n\t\t\talign-items: center;\r\n\r\n\t\t\t.quiz_detail {\r\n\t\t\t\twidth: 30%;\r\n\t\t\t}\r\n\t\t\t.detail-chart {\r\n\t\t\t\twidth: 22%;\r\n\t\t\t}\r\n\t\t}\r\n\t\t.detail-chart {\r\n\t\t\twidth: 45%;\r\n\r\n\t\t\t&__loading{\r\n\t\t\t\tposition:relative;\r\n\r\n\t\t\t\t>:not(.components-spinner){\r\n\t\t\t\t\topacity: .2;\r\n\t\t\t\t\tpointer-events: none;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t>.components-spinner{\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\ttop: 50%;\r\n\t\t\t\t\tleft: 50%;\r\n\t\t\t\t\tmargin-top: -10px;\r\n\t\t\t\t\tmargin-left: -10px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\tul.subsubsub {\r\n\t\t\t\tmargin-bottom: 20px;\r\n\t\t\t\tli {\r\n\t\t\t\t\tmargin-right: 5px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.ct-chart {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: space-between;\r\n\t\t\t\talign-items: center;\r\n\r\n\t\t\t\t.ct-left {\r\n\t\t\t\t\twidth: 55%;\r\n\t\t\t\t}\r\n\t\t\t\t.ct-right {\r\n\t\t\t\t\twidth: 45%;\r\n\t\t\t\t\ttext-align: left;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t\t.title-chart {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\r\n\t\t\tp {\r\n\t\t\t\tfont-style: italic;\r\n\t\t\t\tfont-size: 14px;\r\n\t\t\t\tpadding-left: 10px;\r\n\t\t\t}\r\n\t\t\t&.center {\r\n\t\t\t\tjustify-content: center;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.number_retake {\r\n\t\tdisplay: inline;\r\n\t\tposition: relative;\r\n\r\n\t\tspan.count_retake {\r\n\t\t\tpadding: 8px;\r\n\t\t\tcursor: pointer;\r\n\t\t}\r\n\t}\r\n\tspan.lp-gradebook-item__title{\r\n\t\ttext-overflow: ellipsis;\r\n\t\twhite-space: nowrap;\r\n\t\toverflow: hidden;\r\n\t\tdisplay: inline-block;\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t.lp-skeleton-animation {\r\n\t\tli {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 30px;\r\n\t\t\tborder-radius: \"4px\";\r\n\t\t}\r\n\t}\r\n\t.pagination {\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\tpadding-left: 0;\r\n\t\tlist-style: none;\r\n\t\tborder-radius: 0.25rem;\r\n\t\tmargin-top: 20px;\r\n\r\n\t\tli {\r\n\t\t\tposition: relative;\r\n\t\t\tmargin-left: -1px;\r\n\t\t\tline-height: 1.25;\r\n\t\t\tcolor: #2271b1;\r\n\t\t\tbackground-color: #fff;\r\n\t\t\tborder: 1px solid #dee2e6;\r\n\t\t\tcursor: pointer;\r\n\r\n\t\t\t&.active {\r\n\t\t\t\tz-index: 1;\r\n\t\t\t\tcolor: #fff;\r\n\t\t\t\tbackground-color: #2271b1;\r\n\t\t\t\tborder-color: #2271b1;\r\n\t\t\t\ta {\r\n\t\t\t\t\tcolor: white;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\ta {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\twidth: 33px;\r\n\t\t\t\theight: 33px;\r\n\t\t\t\tjustify-content: center;\r\n\t\t\t\talign-items: center;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.wp-list-table{\r\n\t&.lp-gradebook-spinner {\r\n\t\tposition: relative;\r\n\r\n\t\ttbody{\r\n\t\t\topacity: 0.2;\r\n\t\t}\r\n\r\n\t\t>.components-spinner{\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 50%;\r\n\t\t\tleft: 50%;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.lp-gradebook-overlay{\r\n\tbackground-color: rgba(0,0,0,.05);\r\n\t.components-modal__frame{\r\n\t\tbox-shadow: 0 0 2px 0 #ccc;\r\n\t}\r\n}\r\n\r\n.lp-gradebook_retake {\r\n\twidth: 150px;\r\n\t.lp-gradebook_retake_detail{\r\n\t\tdisplay:flex;\r\n\t\tjustify-content: space-between;\r\n\t\tpadding:10px 15px;\r\n\t\tcursor: pointer;\r\n\t\tfont-size: 13px;\r\n\t\tfont-weight: normal;\r\n\t\tbackground-color:#f6f7f7;\r\n\r\n\t\t&:nth-child(2n+1){\r\n\t\t\tbackground-color:#fff;\r\n\t\t}\r\n\t}\r\n}\r\n.components-dropdown__content.lp-gradebook_my_popover_content{\r\n\t.components-popover__content {\r\n\t\tbox-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);\r\n\t\tborder-radius: 5px;\r\n\t\t> div {\r\n\t\t\tpadding:0;\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
